// Remembers that this browser first played as an invited guest, so a later
// signup can be credited to the invite loop in analytics.
const KEY = "dp_signup_ref";

interface InviteReferral {
  source: "invite";
  session_id: string;
}

export function rememberInviteReferral(sessionId: string): void {
  try {
    const ref: InviteReferral = { source: "invite", session_id: sessionId };
    localStorage.setItem(KEY, JSON.stringify(ref));
  } catch {
    // Storage can be unavailable (private mode); attribution is best effort.
  }
}

/** Properties to add to the signup event, empty when there was no invite. */
export function signupReferralProps(): Record<string, string> {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const ref = JSON.parse(raw) as InviteReferral;
    return { signup_source: ref.source, invited_to_session_id: ref.session_id };
  } catch {
    return {};
  }
}
